import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AppComponent } from '../components/app.component';
import { ReservationViewComponent } from '../components/reservation-view/reservation-view.component';
import { LoginViewComponent } from '../components/login-view/login-view.component';
import { ManagementViewComponent } from '../components/management-view/management-view.component';

import { FilterViewComponent } from '../components/reservation-view/filter-view/filter-view.component';
import { OrderViewComponent } from '../components/reservation-view/order-view/order-view.component';
import { ActiveViewComponent } from '../components/reservation-view/active-view/active-view.component';
import { RegistrationViewComponent } from '../components/reservation-view/registration-view/registration-view.component';
import { ConditionsViewComponent } from '../components/reservation-view/conditions-view/conditions-view.component';
import { ConfirmationViewComponent } from '../components/reservation-view/confirmation-view/confirmation-view.component';
import { SettingsViewComponent } from '../components/reservation-view/settings-view/settings-view.component';

import { RecipesViewComponent } from '../components/management-view/recipes-view/recipes-view.component';
import { RecipeViewComponent } from '../components/management-view/recipes-view/recipe-view/recipe-view.component';
import { CategoriesViewComponent } from '../components/management-view/categories-view/categories-view.component';
import { CabinetsViewComponent } from '../components/management-view/cabinets-view/cabinets-view.component';
import { UsersViewComponent } from '../components/management-view/users-view/users-view.component';
import { UserViewComponent } from '../components/management-view/users-view/user-view/user-view.component';
import { ReportsViewComponent } from '../components/management-view/reports-view/reports-view.component';
import { ReportUsageViewComponent } from '../components/management-view/reports-view/report-usage-view/report-usage-view.component';
import { AdministratorsViewComponent } from '../components/management-view/administrators-view/administrators-view.component';
import { CustomNotificationsViewComponent } from '../components/management-view/customnotifications-view/customnotifications-view.component';
import { CustomNotificationViewComponent } from '../components/management-view/customnotifications-view/customnotification-view/customnotification-view.component';

import { AuthGuard } from './auth-guard';
import { AdHocAuthGuard } from './ad-hoc-auth-guard';
import { ConditionsAuthGuard } from './conditions-auth-guard';

const appRoutes: Routes = [
	{ path: '', component: AppComponent, children: [

		// Shared login
		{ path: 'login', component: LoginViewComponent },

		// SAML login
		{ path: 'saml', component: LoginViewComponent },

		// SAML validation
		{ path: 'validate', component: LoginViewComponent },

		// Reservation
		{ path: 'reservation', component: ReservationViewComponent, children: [
			{ path: 'filter', component: FilterViewComponent, canActivate: [AuthGuard, ConditionsAuthGuard] },
			{ path: 'overview', component: FilterViewComponent, canActivate: [AuthGuard, ConditionsAuthGuard] },
			{ path: 'active', component: ActiveViewComponent, canActivate: [AuthGuard, ConditionsAuthGuard] },
			{ path: 'ict-box', component: OrderViewComponent, canActivate: [AuthGuard, ConditionsAuthGuard, AdHocAuthGuard] }, // defective-item
			{ path: 'drop-box', component: OrderViewComponent, canActivate: [AuthGuard, ConditionsAuthGuard, AdHocAuthGuard] }, // orders/new
			{ path: 'registration/:id', component: RegistrationViewComponent, canActivate: [AuthGuard, ConditionsAuthGuard] },
			{ path: 'conditions', component: ConditionsViewComponent, canActivate: [AuthGuard] },
			{ path: 'confirmation', component: ConfirmationViewComponent, canActivate: [AuthGuard, ConditionsAuthGuard] },
			{ path: 'settings', component: SettingsViewComponent, canActivate: [AuthGuard, ConditionsAuthGuard] },
			{ path: '', redirectTo: '/reservation/overview', pathMatch: 'full' }
		], canActivate: [AuthGuard]},

		// Management
		{ path: 'management', component: ManagementViewComponent, children: [
			{ path: 'recipes', component: RecipesViewComponent, canActivate: [AuthGuard, ConditionsAuthGuard] },
			{ path: 'recipe', component: RecipeViewComponent, canActivate: [AuthGuard, ConditionsAuthGuard] },
			{ path: 'recipe/:id', component: RecipeViewComponent, canActivate: [AuthGuard, ConditionsAuthGuard] },
			{ path: 'categories', component: CategoriesViewComponent, canActivate: [AuthGuard, ConditionsAuthGuard] },
			{ path: 'cabinets', component: CabinetsViewComponent, canActivate: [AuthGuard, ConditionsAuthGuard] },
			{ path: 'users', component: UsersViewComponent, canActivate: [AuthGuard, ConditionsAuthGuard] },
			{ path: 'user', component: UserViewComponent, canActivate: [AuthGuard, ConditionsAuthGuard] },
			{ path: 'user/:id', component: UserViewComponent, canActivate: [AuthGuard, ConditionsAuthGuard] },
			{ path: 'reports', component: ReportsViewComponent, canActivate: [AuthGuard, ConditionsAuthGuard] },
			{ path: 'report/:id', component: ReportUsageViewComponent, canActivate: [AuthGuard, ConditionsAuthGuard] },
			{ path: 'administrators', component: AdministratorsViewComponent, canActivate: [AuthGuard, ConditionsAuthGuard] },
			{ path: 'customnotifications', component: CustomNotificationsViewComponent, canActivate: [AuthGuard, ConditionsAuthGuard] },
			{ path: 'customnotification/:id', component: CustomNotificationViewComponent, canActivate: [AuthGuard, ConditionsAuthGuard] },
			{ path: '', redirectTo: '/management/recipes', pathMatch: 'full', canActivate: [AuthGuard, ConditionsAuthGuard] },
		], canActivate: [AuthGuard, ConditionsAuthGuard, AdHocAuthGuard]},
		{ path: '', redirectTo: '/login', pathMatch: 'full' },

		// Exit
		{ path: 'exit', component: LoginViewComponent },

		{ path: '**', redirectTo: '/login', pathMatch: 'full' }
	]}
];

export const appRoutingProviders: any[] = [];
export const AppRouting: ModuleWithProviders = RouterModule.forRoot(appRoutes);
